import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BasetaoGuide from "../pages/basetao-spreadsheet-guide/page";
import ShoppingGuide from "../pages/shopping-guide/page";
import WhatIsBasetaoSpreadsheet from "../pages/what-is-basetao-spreadsheet/page";
import HowToUseBasetaoSpreadsheet from "../pages/how-to-use-basetao-spreadsheet/page";
import BasetaoSpreadsheetTutorial from "../pages/basetao-spreadsheet-tutorial/page";
import BasetaoReview2026 from "../pages/basetao-review-2026/page";
import IsBasetaoLegit from "../pages/is-basetao-legit/page";
import BasetaoShippingCost from "../pages/basetao-shipping-cost/page";
import BasetaoCouponGuide from "../pages/basetao-coupon-guide/page";
import BasetaoWarehouseGuide from "../pages/basetao-warehouse-guide/page";
import BasetaoQCGuide from "../pages/basetao-qc-guide/page";
import BasetaoBeginnerGuide from "../pages/basetao-beginner-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/basetao-spreadsheet-guide",
    element: <BasetaoGuide />,
  },
  {
    path: "/shopping-guide",
    element: <ShoppingGuide />,
  },
  {
    path: "/what-is-basetao-spreadsheet",
    element: <WhatIsBasetaoSpreadsheet />,
  },
  {
    path: "/how-to-use-basetao-spreadsheet",
    element: <HowToUseBasetaoSpreadsheet />,
  },
  {
    path: "/basetao-spreadsheet-tutorial",
    element: <BasetaoSpreadsheetTutorial />,
  },
  {
    path: "/basetao-review-2026",
    element: <BasetaoReview2026 />,
  },
  {
    path: "/is-basetao-legit",
    element: <IsBasetaoLegit />,
  },
  {
    path: "/basetao-shipping-cost",
    element: <BasetaoShippingCost />,
  },
  {
    path: "/basetao-coupon-guide",
    element: <BasetaoCouponGuide />,
  },
  {
    path: "/basetao-warehouse-guide",
    element: <BasetaoWarehouseGuide />,
  },
  {
    path: "/basetao-qc-guide",
    element: <BasetaoQCGuide />,
  },
  {
    path: "/basetao-beginner-guide",
    element: <BasetaoBeginnerGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;